import styled from 'styled-components';
import { StyledModal } from '../../common/shared/modal.styled';

export const StyledEditContactModal = styled(StyledModal)`
  .modal-dialog {
    max-width: 800px;
  }

  .inputs {
    margin-bottom: 20px;

    .input-container {
      margin-bottom: 30px;
    }
  }

  .buttons {
    display: flex;
    justify-content: center;
    
    button {
      margin: 0 40px;
      width: 200px;
    }
  }
`;